<template>
  <div class="portal-app-page">
    <RetailerHeader />
    <main class="not-found-page portal-container">
      <div class="not-found-page__code">404</div>
      <span class="eyebrow">Page not found</span>
      <h1>We couldn’t find that page</h1>
      <p>The link may be outdated or the page may have moved. Return to the partner portal home to continue.</p>
      <router-link to="/" class="uk-button uk-button-primary">Back to home</router-link>
    </main>
    <RetailerFooter />
  </div>
</template>

<script>
import RetailerHeader from './components/RetailerHeader.vue'; 
import RetailerFooter from './components/RetailerFooter.vue'; 

export default {
  created() {
    document.title = 'Page Not Found | UCARI';
  },
  components: {
    RetailerHeader,
    RetailerFooter
  }
};
</script>
